import React from "react";
import { Layout, Form, Input, Button, Spin } from "antd";
import { UserOutlined, LockOutlined } from "@ant-design/icons";
import "./login.css";
import axios from "../../util/api";
import { useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { actHideLoading, actShowLoading } from "../../actions/actionLoading";
import { addFormData, openNotificationWithIcon } from "../../util/help";

function Login() {
  let history = useHistory();
  const dispatch = useDispatch();

  const isLoading = useSelector((state) => state.isLoading);

  const showLoading = () => dispatch(actShowLoading());
  const hideLoading = () => dispatch(actHideLoading());

  const onFinish = (values) => {
    showLoading();
    axios
      .post("user/login", addFormData(values))
      .then((res) => {
        if (res.status === 200) {
          if (res.data.success === true) {
            localStorage.setItem("BRANCH_ID", res.data.data.BRANCH_ID);
            localStorage.setItem("INPUT_USER", res.data.data.INPUT_USER);
            localStorage.setItem("USER_NO", res.data.data.USER_NO);
            hideLoading();
            history.push("Dasboard/khachhang");
            openNotificationWithIcon("success", res.data.message);
          }
        }
      })
      .catch((err) => {
        if (err.response.status === 400) {
          if (err.response.data.success === false) {
            hideLoading();
            openNotificationWithIcon("error", err.response.data.message);
          }
        }
      });
  };

  return (
    <Layout style={{ background: "#fff" }} className="content">
      <Spin size="large" spinning={isLoading}>
        <Form name="normal_login" className="login-form" onFinish={onFinish}>
          <Form.Item
            name="user_no"
            rules={[
              {
                required: true,
                message: "Please input your Username!",
              },
            ]}
          >
            <Input
              prefix={<UserOutlined className="site-form-item-icon" />}
              placeholder="Username"
              size="large"
            />
          </Form.Item>
          <Form.Item
            name="user_pwd"
            rules={[
              {
                required: true,
                message: "Please input your Password!",
              },
            ]}
          >
            <Input
              prefix={<LockOutlined className="site-form-item-icon" />}
              type="password"
              placeholder="Password"
              size="large"
            />
          </Form.Item>
          <Form.Item>
            <Button
              type="primary"
              htmlType="submit"
              className="login-form-button"
              size="large"
            >
              Log in
            </Button>
          </Form.Item>
        </Form>
      </Spin>
    </Layout>
  );
}

export default Login;
